import { SvgIcon, SvgIconProps, useTheme } from '@material-ui/core';
import React from 'react';

export const Folder = (props: SvgIconProps): JSX.Element => {
  const theme = useTheme();

  return (
    <SvgIcon {...props}>
      <path
        fill={theme.palette?.document?.folder}
        d="M10 4H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-8l-2-2Z"
      />
    </SvgIcon>
  );
};
